import * as utils from "../misc.js";
import * as accordion from "../plugins/accordion.js";

export function init_priceslider(min, max) {
  jQuery(".price-slider").slider({
    range: true,
    min: min - 1,
    max: max,
    values: [min, max],
    create: function () {
      jQuery(".price_label span.from").html("$" + min);
      jQuery(".price_label span.to").html("$" + max);
    },
    stop: function (event, ui) {
      jQuery(this).attr("data-min", ui.values[0]);
      jQuery(this).attr("data-max", ui.values[1]);
      jQuery(".woo_filters").attr("data-pageno", 1);
      do_woofilter(2000);
    },
    slide: function (event, ui) {
      jQuery(".price_label span.from").html("$" + ui.values[0]);
      jQuery(".price_label span.to").html("$" + ui.values[1]);
    },
  });
}

export function loadPriceSlider(pricelow, pricehigh) {
  var current_min_price = pricelow,
    current_max_price = pricehigh;

  if (pricelow == -1 && pricehigh == -1) {
    if (jQuery(".price-slider").length > 0) {
      current_min_price = jQuery(".price_label span.from")
        .html()
        .replace(/[^\d.-]/g, "");
      current_max_price = jQuery(".price_label span.to")
        .html()
        .replace(/[^\d.-]/g, "");
    }
  }

  if (jQuery(".price-slider").length > 0) {
    init_priceslider(current_min_price, current_max_price);
  }
}

function do_woofilter(timeout) {
  jQuery(".productsblock .products").html(
    "<li class='loading'><div class='icon-loading'></div></li>",
  );
  const setpricefiltertimeout = setTimeout(() => {
    do_woo_filters();
    clearTimeout(setpricefiltertimeout);
  }, timeout);
}

function reInit(filtergroupArr) {
  //reload the accordion

  if (filtergroupArr) {
    filtergroupArr.forEach((group) => {
      const filtergroup = group.filtergroup;
      const values = group.values;
      values.forEach((val) => {
        jQuery("li[data-attval='" + val + "']").addClass("active");
        jQuery("input[type='checkbox'][value='" + val + "']").attr(
          "checked",
          true,
        );
      });
    });
  }
  let newAccordion;
  jQuery(".accordion").each(function (fn, el) {
    newAccordion = accordion.initAccordion(el);
  });

  init();

  return newAccordion;
}

export function init() {
  loadPriceSlider(-1, -1);

  jQuery(".accordion").each(function (fn, el) {
    accordion.initAccordion(el);
  });

  jQuery(".woocommerce-product-results .filters_button").on(
    "click",
    function () {
      if (jQuery(".woo_filters").hasClass("active")) {
        jQuery(".woo_filters").removeClass("active");
        jQuery(this).html("Show Filters");
      } else {
        jQuery(".woo_filters").addClass("active");
        jQuery(this).html("Hide Filters");
      }
    },
  );

  jQuery(".woo_filters input[name='filtersearch']").on("change", function () {
    jQuery(".woo_filters").attr("data-pageno", 1);
    do_woofilter(500);
  });

  jQuery(".woo_filters ul li").on("click", function () {
    jQuery(this).toggleClass("active");

    //jQuery(this).find("input[type='checkbox']").toggleAttr("checked");

    if (jQuery(this).hasClass("active")) {
      jQuery(this).find("input[type='checkbox']").attr("checked", true);
    } else {
      jQuery(this).find("input[type='checkbox']").attr("checked", false);
    }
    jQuery(".woo_filters").attr("data-pageno", 1);
    do_woofilter(500);
  });

  jQuery(".productsblock").on(
    "click",
    ".woocommerce-pagination ul li a",
    function (e) {
      if (jQuery(".woo_filters").length > 0) {
        e.preventDefault();
        var pageno = jQuery(this).html();

        jQuery(".woo_filters").attr("data-pageno", pageno);
        do_woo_filters();
      }
    },
  );
}

function getSelectedFilters() {
  const filters = {};

  document.querySelectorAll(".filtergroup").forEach((group) => {
    const taxonomy = group.dataset.attrgroup;

    const checked = [...group.querySelectorAll("input:checked")].map((input) =>
      parseInt(input.value),
    );

    if (checked.length) {
      filters[taxonomy] = checked;
    }
  });

  return filters;
}

function do_woo_filters() {
  var filters = [];
  var tax = document.querySelector(".woo_filters")?.dataset.tax;
  var term = document.querySelector(".woo_filters")?.dataset.term;
  var perpage = document.querySelector(".woo_filters")?.dataset.perpage;
  var pageno = document.querySelector(".woo_filters")?.dataset.pageno
    ? parseInt(document.querySelector(".woo_filters")?.dataset.pageno)
    : 1;
  var pricefrom = document.querySelector(".price-slider")?.dataset.min;
  var priceto = document.querySelector(".price-slider")?.dataset.max;
  var saleonly = document.querySelector(".woo_filters")?.dataset.saleonly;
  var s = document.querySelector("input[name='filtersearch']")?.value;
  var orderby = document.querySelector(".woocommerce-ordering .orderby")?.value;

  var filtergroupArr = [];

  document
    .querySelectorAll(".woo_filters div.filtergroup")
    .forEach(function (group) {
      var filtergroupid = group.dataset.attrgroup;
      var filtergroupvals = [];

      group
        .querySelectorAll("li input[type='checkbox']:checked")
        .forEach(function (attrval) {
          var filterid = attrval.value;
          filtergroupvals.push(filterid);
        });

      if (filtergroupvals.length) {
        filtergroupArr.push({
          filtergroup: filtergroupid,
          values: filtergroupvals,
        });
      }
    });

  utils.scrollTo(".woocommerce-product-results", 50);

  fetch("/wp-json/woo/v1/products", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      tax,
      term,
      perpage,
      pageno,
      s,
      saleonly,
      orderby,
      filters: filtergroupArr,
    }),
  })
    .then((res) => res.json())
    .then((r) => {
      var from = r.from;
      var to = r.to;
      var total = r.total;
      jQuery("ul.products").html(r.productsHTML);
      jQuery(".woocommerce-result-count").html(
        `Showing ${from}-${to} of ${total} results`,
      );
      var total = r.total;
      var perpage = r.perpage;
      var paginationHTML = "";

      const el = document.querySelector(".woo_filters");

      if (el) {
        let $accordion = jQuery(".woo_filters .accordion");

        let activePanel = $accordion.attr("data-activepanel");
        console.log("got activePanel: ", activePanel);
        el.innerHTML = r.filtersHTML;

        if (activePanel) {
          jQuery(".woo_filters .accordion").each(function (fn, el) {
            jQuery(el).attr("data-activepanel", activePanel);
          });
        }

        $accordion = reInit(filtergroupArr);
      }
      var maxpages = Math.ceil(total / perpage);
      var paginationHTML = "";

      if (maxpages <= 10) {
        // small number of pages, show all
        for (var a = 1; a <= maxpages; a++) {
          var thisclass = a == pageno ? "class='current'" : "";
          paginationHTML += `<li><a ${thisclass}>${a}</a></li>`;
        }
      } else {
        // large number of pages
        // Show first 4 pages
        for (var a = 1; a <= 4; a++) {
          var thisclass = a == pageno ? "class='current'" : "";
          paginationHTML += `<li><a ${thisclass}>${a}</a></li>`;
        }

        paginationHTML += `<li><span class='dots'>…</span></li>`; // ellipsis

        // Show last 3 pages
        for (var a = maxpages - 2; a <= maxpages; a++) {
          var thisclass = a == pageno ? "class='current'" : "";
          paginationHTML += `<li><a ${thisclass}>${a}</a></li>`;
        }
      }

      // Insert into DOM
      if (jQuery(".woocommerce-pagination ul").length == 0) {
        jQuery(".productsblock").append(
          "<nav class='woocommerce-pagination'><ul class='page-numbers'>" +
            paginationHTML +
            "</ul></nav>",
        );
      } else {
        jQuery(".woocommerce-pagination ul").html(paginationHTML);
      }
    });
}
